/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Prescription_DateInputs */

const en_case_prescription_date = /** @type {(inputs: Case_Prescription_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prescription date`)
};

const pt_br2_case_prescription_date = /** @type {(inputs: Case_Prescription_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data prescrição`)
};

/**
* | output |
* | --- |
* | "Prescription date" |
*
* @param {Case_Prescription_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_prescription_date = /** @type {((inputs?: Case_Prescription_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Prescription_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_prescription_date(inputs)
	return pt_br2_case_prescription_date(inputs)
});